var exports = {
  "k": "xfb577c5e--2c156f--container",
};

module.exports = exports;
